/**
 * Catálogo de permisos CRUD + alias caja (alineado con functions/utils/permisosCatalog.js).
 */

import { MODULE_KEYS } from './modulesCatalog';

export const ACCIONES_CRUD = ['ver', 'crear', 'editar', 'eliminar'];

export const CAJA_ACCIONES_LEGACY = [
  { id: 'cerrar', label: 'Cerrar caja (alias crear)' },
  { id: 'ver_cierres', label: 'Ver historial de cierres' },
  { id: 'corregir_cierre', label: 'Corregir cierre (alias editar)' }
];

export const REPORTES_ACCIONES_EXTRA = [
  { id: 'ver_ganancias', label: 'Ver ganancias / rentabilidad' }
];

export const COMPRAS_ACCIONES_EXTRA = [
  { id: 'recibir', label: 'Recibir mercadería' },
  { id: 'pagar', label: 'Pagar compras / CxP / reversar pagos' },
  { id: 'anular', label: 'Anular compras' }
];

export const PRODUCTOS_ACCIONES_EXTRA = [
  { id: 'costos.ver', label: 'Ver costos de producto' }
];

export const PROVEEDORES_ACCIONES_EXTRA = [
  { id: 'cuenta_corriente.ver', label: 'Ver cuenta corriente / CxP' },
  { id: 'facturas.crear', label: 'Crear facturas / notas CxP' }
];

export const CAJA_PRESETS_POR_ROL = {
  admin: { ver: true, crear: true, editar: true, eliminar: true, cerrar: true, ver_cierres: true, corregir_cierre: true },
  gerente: { ver: true, crear: true, editar: true, eliminar: false, cerrar: true, ver_cierres: true, corregir_cierre: true },
  cajero: { ver: true, crear: true, editar: false, eliminar: false, cerrar: true, ver_cierres: false, corregir_cierre: false },
  empleado: { ver: false, crear: false, editar: false, eliminar: false, cerrar: false, ver_cierres: false, corregir_cierre: false }
};

export function syncCajaPermisosBlock(caja = {}) {
  const next = { ...caja };
  if (next.crear === false || next.cerrar === false) {
    next.crear = false;
    next.cerrar = false;
  } else if (next.crear === true || next.cerrar === true) {
    next.crear = true;
    next.cerrar = true;
  }
  if (next.editar === false || next.corregir_cierre === false) {
    next.editar = false;
    next.corregir_cierre = false;
  } else if (next.editar === true || next.corregir_cierre === true) {
    next.editar = true;
    next.corregir_cierre = true;
  }
  return next;
}

export function buildPermisosVacios() {
  const vacio = { ver: false, crear: false, editar: false, eliminar: false };
  return Object.fromEntries(MODULE_KEYS.map((k) => [k, { ...vacio }]));
}

export { MODULE_KEYS };
